module.exports = __webpack_public_path__ + "static/img/28.b975dc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/28.jpg
// module id = L4/7
// module chunks = 0